import { Request } from './Request';

export interface IRemoteAgentConnectionStatus {
  agentName: string;
  connectionStatus: string;
}

export interface IGetSiteRemoteAgentsConnectionStatusParams {
}

export interface IGetSiteRemoteAgentsConnectionStatusResult {
  agents: IRemoteAgentConnectionStatus[];
}

export class GetSiteRemoteAgentsConnectionStatusRequest
  extends Request<IGetSiteRemoteAgentsConnectionStatusParams, IGetSiteRemoteAgentsConnectionStatusResult> {

  constructor(params: IGetSiteRemoteAgentsConnectionStatusParams) {
    super('getSiteRemoteAgentsConnectionStatus', params);
  }
}
